import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ServiceUserDetailPage = lazy(
  () => import('~/features/service-auth/pages/service-user-detail-page'),
);

export const Route = createFileRoute('/_authenticated/_tenant/platform/service-auth/users/$id')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ServiceUserDetailPage />
    </Suspense>
  ),
});
